import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import useSelectedCompany from '../../../../hooks/useSelectedCompany';
import IconStackOverlay from '../../../../components/overlays/IconStackOverlay';
import NationalTaxServiceCredentialsOverlay from '../../../../components/overlays/NationalTaxServiceCredentials/NationalTaxServiceCredentialsOverlay';

const BaseAvailableFactoringOverlay = ({
  title,
  description,
  overlayProps,
  titleProps,
  bodyProps,
  credentialsSource,
}) => {
  const company = useSelectedCompany();
  const hasSiiCredentials = company?.hasSiiCredentials;

  if (hasSiiCredentials) {
    return (
      <IconStackOverlay {...overlayProps}>
        <Typography {...titleProps}>
          {title}
        </Typography>
        <Typography {...bodyProps}>
          {description}
        </Typography>
      </IconStackOverlay>
    );
  }

  return <NationalTaxServiceCredentialsOverlay source={credentialsSource} />;
};

BaseAvailableFactoringOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  overlayProps: PropTypes.shape({}),
  titleProps: PropTypes.shape({}),
  bodyProps: PropTypes.shape({}),
  credentialsSource: PropTypes.string,
};

BaseAvailableFactoringOverlay.defaultProps = {
  overlayProps: {},
  titleProps: { variant: 'h4', paragraph: true },
  bodyProps: { variant: 'body1', paragraph: true },
  credentialsSource: null,
};

export default BaseAvailableFactoringOverlay;
